import React, { useContext, useEffect, useState } from 'react';
import ApiURL from '../Api/Api';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { SidebarContext } from './SidebarContext';

const CompanySummary = () => {
  const companyId = localStorage.getItem('company_id') || '';
  const [summary, setSummary] = useState([]);
  const [error, setError] = useState('');
  const { isSidebarOpen } = useContext(SidebarContext);

  useEffect(() => {
    fetch(`${ApiURL}/getCompanySummary.php?company_id=${companyId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'success') {
          setSummary(data.summary || []);
        } else {
          setError(data.message || 'Failed to load summary');
        }
      })
      .catch((err) => setError(err.message));
  }, [companyId]);

  return (
    <div className="app-shell min-h-screen pt-16">
      <Navbar />
      <Sidebar />
      <main className={`min-w-0 p-4 sm:p-6 transition-all duration-300 ${isSidebarOpen ? 'lg:ml-72' : ''}`}>
        <section className="page-surface mb-5 p-4 sm:p-5">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-600">Company Management</p>
          <h1 className="mt-1 text-2xl font-black text-slate-900">User Summary</h1>
          <p className="mt-1 text-sm text-slate-500">Site-wise admin and worker distribution.</p>
        </section>
        {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">{error}</div>}
        <div className="pro-card overflow-hidden">
          <div className="overflow-x-auto">
          <table className="w-full min-w-[560px] text-sm">
            <thead className="bg-slate-100">
              <tr>
                <th className="text-left px-4 py-3">Site</th>
                <th className="text-left px-4 py-3">Admins</th>
                <th className="text-left px-4 py-3">Workers</th>
              </tr>
            </thead>
            <tbody>
              {summary.map((row) => (
                <tr key={row.site_id} className="border-t">
                  <td className="px-4 py-3">{row.site_name}</td>
                  <td className="px-4 py-3">{row.admin_count}</td>
                  <td className="px-4 py-3">{row.worker_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CompanySummary;
